export default "__VITE_ASSET__eX$pBvmH__"